module.exports = __webpack_public_path__ + "static/media/grid-image5.dd70e7a8.jpg";